import React, { useState } from 'react';
import {
  Box,
  Divider,
  Typography,
  Radio,
  List,
  ListItem,
  Avatar,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';

const ApprovalLineForm = ({ approvalLines }) => {
  // const [checkedValue, setCheckedValue] = useState(null);

  // const handleChange = (event) => {
  //   setCheckedValue(event.target.value);
  //   setApprUuid(event.target.value);
  // };

  return (
    <Box sx={{ my: 1, px: 2 }}>
      {approvalLines &&
        approvalLines.map((line, index) => (
          <div key={index}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                my: 1,
              }}
            >
              {/* <Box>
                <Radio
                  checked={checkedValue === line?.apprUuid}
                  onChange={handleChange}
                  value={line?.apprUuid}
                  name={line?.apprNm}
                  inputProps={{ 'aria-label': `${line.apprNm}` }}
                />
              </Box> */}
              <Box>
                <Typography variant="subtitle2" gutterBottom component="div">
                  {line.apprNm}
                </Typography>
              </Box>
            </Box>
            <List
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                padding: 0,
              }}
              component="div"
              aria-labelledby="approval-list-subheader"
            >
              <ListItem>
                <ListItemAvatar>
                  <Avatar src={line?.usrUuid1Profile}></Avatar>
                </ListItemAvatar>
                <ListItemText primary={line?.usrUuid1Nm} secondary="결재자1" />
                {line.usrUuid2 && (
                  <>
                    <ListItemAvatar>
                      <Avatar src={line?.usrUuid2Profile}></Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={line?.usrUuid2Nm}
                      secondary="결재자2"
                    />
                  </>
                )}
                {line.usrUuid3 && (
                  <>
                    <ListItemAvatar>
                      <Avatar src={line?.usrUuid3Profile}></Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={line?.usrUuid3Nm}
                      secondary="결재자3"
                    />
                  </>
                )}
                {line.usrUuid4 && (
                  <>
                    <ListItemAvatar>
                      <Avatar src={line?.usrUuid4Profile}></Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={line?.usrUuid4Nm}
                      secondary="결재자4"
                    />
                  </>
                )}
                {line.usrUuid5 && (
                  <>
                    <ListItemAvatar>
                      <Avatar src={line?.usrUuid5Profile}></Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={line?.usrUuid5Nm}
                      secondary="결재자5"
                    />
                  </>
                )}
              </ListItem>
            </List>
            <Divider />
          </div>
        ))}
    </Box>
  );
};

export default ApprovalLineForm;
